import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

function Reveal({ children, delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  return (
    <motion.div ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
}

export default function OfflineClasses() {
  const navigate = useNavigate();

  return (
    <section id="offline-classes" className="section-pad" style={{ background: '#FAF7F0', position: 'relative', overflow: 'hidden' }}>
      <span className="ghost-text" style={{ top: '5%', right: '-4%', fontSize: 'clamp(80px,14vw,200px)' }}>इंदौर</span>

      <div className="max-w">
        <Reveal>
          <span className="eyebrow">Studio Learning</span>
          <h2 className="section-title">Our Music <br /><em style={{ fontStyle: 'italic', color: '#C8922A' }}>Institute</em></h2>
          <div className="section-rule" />
        </Reveal>

        <Reveal delay={0.15}>
          <div style={{
            maxWidth: 720,
            margin: '40px auto 0',
            padding: 'clamp(32px, 8vw, 56px) clamp(20px, 6vw, 48px)',
            background: 'rgba(255,251,244,0.72)',
            border: '1px solid rgba(200,146,42,0.18)',
            borderRadius: 6,
            backdropFilter: 'blur(12px)',
            textAlign: 'center',
            boxShadow: '0 8px 40px rgba(0,0,0,0.04)',
          }}>
            <div style={{ fontSize: 48, marginBottom: 24, opacity: 0.7 }}>🎵</div>
            <h3 style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(26px, 4vw, 40px)',
              fontWeight: 300,
              color: '#1A1209',
              marginBottom: 20,
              lineHeight: 1.25,
            }}>
              Learn Instruments & Vocals
            </h3>
            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 15,
              color: '#7A6E5E',
              lineHeight: 1.85,
              maxWidth: 520,
              margin: '0 auto 36px',
            }}>
              Along with our recording and practice studios, AAROHAN runs a full-fledged musical institute where you can learn different instruments — Guitar, Piano, Drums, Tabla, Flute & more — as well as vocal training across genres. Structured batches, expert faculty, and a creative community await you.
            </p>
            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 13,
              color: 'rgba(26,18,9,0.45)',
              lineHeight: 1.7,
              marginBottom: 36,
            }}>
              To know more about our offline classes, batch timings, and fees — please contact our studio directly.
            </p>

            <motion.button
              whileHover={{ y: -2, boxShadow: '0 8px 32px rgba(200,146,42,0.22)' }}
              whileTap={{ scale: 0.97 }}
              onClick={() => {
                const el = document.getElementById('contact');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  navigate('/#contact');
                }
              }}
              style={{
                padding: '16px 48px',
                background: '#1A1209',
                color: '#FAF7F0',
                border: 'none',
                borderRadius: 2,
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: '3px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                fontFamily: "'DM Sans', sans-serif",
                transition: 'all 0.3s',
              }}
            >
              Contact Studio →
            </motion.button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

